export interface AssessmentPackageMetadata {
    /**
     * Optional id for internal use within the service worker's database.
     */
    id?: number; 
    /**
     * The filename of the assessment package.
     */
    filename: string;
    /**
     * The size of the assessment package in bytes.
     */
    filesize: number;
    /**
     * The school code of the assessment package - only set for school assessments.
     */
    school_code?: number;
    /**
     * The timestamp of the assessment package.
     */
    timestamp: string;
    /**
     * The type of the assessment package.
     */
    package_type: string;
    /**
     * The validity end date of the assessment package.
     */
    valid_to: string;            
    /**
     * The validity start date of the assessment package.
     */
    valid_from: string;    
    /**
     * The environment of the assessment package. UAT/SIT/PRODUCTION/DEV4
     */
    env: string;    
    /**
     * The UUID of the assessment (not the package, it identifies the content of the package)
     */
    assessment_uuid: string;    
    /**
     * The subject of the assessment package.
     */
    subject: string;
    /**
     * The year of the assessment package.
     */
    year?: number;
    /**
     * The month of the assessment package.
     */
    month?: number;
    /**
     * The title of the assessment package.
     */
    title: string;
    /**
     * The language of the assessment package.
     */
    language: string;
    /**
     * The input language of the assessment package.
     */
    input_language?: string;
    /**
     * Indicates if the system language is selectable for the assessment package.
     */
    system_lang_selectable: boolean;
    /**
     * The API URL for response upload.
     */
    response_upload_api_url: string;    
    /**
     * The API URL for hybrid response upload.
     */
    hybrid_response_api_url: string;
    
}
